import { AlertTriangle, Check, X } from "lucide-react";

const DEFAULT_TEXT = `You have not attempted all of the questions in this section and time is still remaining.

If you select Finish Section, you will not be able to return to the section.

Are you sure you would like to finish this section?`;

// Confirmation shown before submitting the MCQ section of a merged exam.
const FinishSectionModal = ({
  open,
  text,
  onConfirm,
  onCancel,
}: {
  open: boolean;
  text?: string;
  onConfirm: () => void;
  onCancel: () => void;
}) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[9999] bg-black/40 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center shadow-2xl">
        <div className="flex justify-center mb-5">
          <AlertTriangle size={64} className="text-white" fill="#F5A623" />
        </div>
        <p className="text-[#333] mb-6 whitespace-pre-line">
          {text ?? DEFAULT_TEXT}
        </p>
        <div className="flex flex-col items-center gap-3">
          <button
            type="button"
            onClick={onConfirm}
            className="w-full bg-[#8cc63f] hover:bg-[#7ab234] text-white rounded-lg py-3 flex items-center justify-center gap-2 font-semibold transition-colors"
          >
            <Check size={18} /> Yes, I would like to finish this section
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="w-full bg-[#8cc63f] hover:bg-[#7ab234] text-white rounded-lg py-3 flex items-center justify-center gap-2 font-semibold transition-colors"
          >
            <X size={18} /> No, I would like to return to this section
          </button>
        </div>
      </div>
    </div>
  );
};

export default FinishSectionModal;
